import { Injectable } from '@angular/core';

@Injectable()
export class DatabusService {
  currentEmail: string = '';
  password: string = '';
  password2: string = '';
  errorMessage: string = '';
  currentTicket: any = '';
  redeemValue: number = 0;
  currentClubCard: any = '';
  currentLogin: any = {};
  currentAccount: any = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    address2: '',
    birthday: '',
    city: '',
    state: ''
  };
  forceRegistration: boolean = false;

  constructor () {}

  setInitProfile(signup) {
    this.currentAccount.firstName = signup.firstName;
    this.currentAccount.lastName = signup.lastName;
    this.currentEmail = signup.email;
    this.password = signup.password;
    this.password2 = signup.password2;
  }

  setExtendProfile(signup) {
    this.currentAccount.birthday = signup.birthday;
    this.currentAccount.address = signup.address;
    this.currentAccount.address2 = signup.address2;
    this.currentAccount.email = signup.email;
    this.currentAccount.phone = signup.phone;
    this.currentAccount.city = signup.city;
    this.currentAccount.state = signup.state;
  }

  initProfileValid() {
    let isValid: boolean = true;
    this.currentAccount.firstName !== '' ? null : isValid = false;
    this.currentAccount.lastName !== '' ? null : isValid = false;
    this.currentEmail !== '' ? null : isValid = false;
    this.password !== '' ? null : isValid = false;
    this.password === this.password2 ? null : isValid = false;
    return isValid;
  }

  extendProfileValid() {
    let isValid: boolean = true;
    this.currentAccount.birthday !== '' ? null : isValid = false;
    this.currentAccount.address !== '' ? null : isValid = false;
    this.currentAccount.city !== '' ? null : isValid = false;
    this.currentAccount.state !== '' ? null : isValid = false;
    this.currentAccount.phone !== '' ? null : isValid = false;
    return isValid;
  }

  reset() {
    this.currentEmail = '';
    this.password = '';
    this.password2 = '';
    this.errorMessage = '';
    this.currentTicket = '';
    this.redeemValue = 0;
    this.currentClubCard = '';
    this.currentLogin = {};
    this.currentAccount = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      address: '',
      address2: '',
      birthday: '',
      city: '',
      state: ''
    }; 
    this.forceRegistration = false;  
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/shared/services/databus.service.ts